// extracted by mini-css-extract-plugin
export var fadeIn = "snackBar-module--fadeIn--f3f5c";
export var fadeOut = "snackBar-module--fadeOut--10499";
export var snackbar = "snackBar-module--snackbar--f6850";
export var snackbarShowing = "snackBar-module--snackbar-showing--65a4a";